var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quiz-header-component",attrs:{"id":"quiz-header"}},[_c('div',{staticClass:"max-1080"},[_c('div',{staticClass:"padding-1 padding-left-2"},[_vm._v(_vm._s(_vm.currentTopic.es_displayname ? _vm.currentTopic.es_displayname : _vm.currentTopic.es_name))]),_c('progress-bar',{key:_vm.currentAttempt+'progressbar'}),_c('timer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }